/*
 * @Description:
 * @Author: huruyang
 * @Date: 2020-03-19 10:10:31
 * @LastEditors: huruyang
 * @LastEditTime: 2020-08-11 18:03:06
 */
import axios from "./axios.js";
import { apiData } from "./api";
function getBaseUrl() {
  let baseUrl = "https://toolplugin-dev.jiaoyanyun.com";
  switch (process.env.env_config) {
    case "prod":
      baseUrl = "https://toolplugin.jiaoyanyun.com";
      break;
    case "fz":
      baseUrl = "https://toolplugin-fz.jiaoyanyun.com";
      break;
    case "development":
      baseUrl = "https://toolplugin-dev.jiaoyanyun.com";
      break;
    case "dev":
      baseUrl = "https://toolplugin-dev.jiaoyanyun.com";
      break;
  }
  return baseUrl;
}
//获取用户信息
const userInfo = params => {
  return axios.get(apiData.userInfo, { params: params });
};
//upload资源
const uploadSource = params => {
  return axios.get(apiData.userInfo, {
    params: params
  });
};
//题目详情
const questionDetail = params => {
  return axios.post(apiData.questionDetail, params);
};

//更新用户信息
const updateUserInfo = params => {
  return axios.post(apiData.updateUserInfo, params);
};
//收藏
const collect = params => {
  return axios.post(apiData.collect, params);
};

//取消收藏
const cancelCollect = params => {
  return axios.post(apiData.cancelCollect, params);
};
//推荐
const recommend = params => {
  return axios.post(apiData.recommend, params);
};
//推荐
const recommend1 = params => {
  return axios.post(apiData.recommend1, params);
};
//获取卡片列表
const cardList = params => {
  return axios.get(apiData.cardList, { params: params });
};
//获取卡片详情
const cardDetail = params => {
  return axios.get(apiData.cardDetail, { params: params });
};
//综合搜索
const search = params => {
  return axios.post(apiData.search, params);
};
//试卷详情
const examDetail = params => {
  return axios.post(apiData.examDetail, params);
};
//查询教材标签
const catalogueTabList = params => {
  return axios.post(apiData.catalogueTabList, params);
};
//获取知识点详情
const knowledgeDetail = params => {
  return axios.post(apiData.knowledgeDetail, params);
};
//获取教材章节列表
const chapterList = params => {
  return axios.post(apiData.chapterList, params);
};
//搜索联想
const searchSuggest = params => {
  return axios.post(apiData.searchSuggest, params);
};
//试卷分析
const examAnalysis = params => {
  return axios.get(apiData.examAnalysis, { params: params });
};
//获取视频信息
const videoDetail = params => {
  return axios.post(apiData.videoDetail, params);
};
const cardItemList = params => {
  return axios.get(apiData.cardItemList, { params: params });
};
//获取试卷列表快照
const examSnapShot = params => {
  return axios.post(apiData.examSnapShot, params);
};

//获取视频列表快照
const videoSnapShot = params => {
  return axios.post(apiData.videoSnapShot, params);
};

//获取卡包试卷详情
const getPaperContentById = params => {
  return axios.get(apiData.getPaperContentById, { params: params });
};
//获取卡包内试题列表
const questionSnapShot = params => {
  return axios.post(apiData.questionSnapShot, params);
};
const examQuestionListByType = params => {
  return axios.post(apiData.examQuestionListByType, params);
};
//增加用户浏览量
const addUserView = params => {
  return axios.get(apiData.userView, { params: params });
};
//用户行为上报
const UserBehavior = params => {
  return axios.post(apiData.UserBehavior, params);
};

//按学科筛选收藏列表
const favouriteSnapShot = params => {
  return axios.get(apiData.favouriteSnapShot, { params: params });
};
//获取每日收藏列表
const favouriteListOfData = params => {
  return axios.get(apiData.favouriteListOfData, { params: params });
};
//获取指定教材列表-用于推荐
const catalogueTabList_part = params => {
  return axios.post(apiData.catalogueTabList_part, params);
};
//查询文段详情
const paragraphDetail = params => {
  return axios.post(apiData.paragraphDetail, params);
};

//实验列表
const experimentList = params => {
  return axios.get(apiData.experimentList, { params: params });
};
//实验详情
const experimentDetail = params => {
  return axios.get(apiData.experimentDetail, { params: params });
};
//微信签名
const wxSignature = params => {
  return axios.get(apiData.wxSignature, { params: params });
};
//晓讲师微信签名
const xjsSignature = params => {
  return axios.get(apiData.xjsSignature, { params: params });
};

//分享页-获取视频详情
const videoDetail_share = params => {
  return axios.get(apiData.share_videoDetail, { params: params });
};

//分享页-更新视频浏览量
const updateViewCount_share = param => {
  return axios.post(apiData.share_viewCount, param);
};
//分享页-更新视频点赞量
const updateLikeCount_share = param => {
  return axios.post(apiData.share_likeCount, param);
};

//分享页-短链接
const shortenLink = params => {
  return axios.get(apiData.share_urlShortCut, { params: params });
};
//分享页-查询文件夹列表
const queryFolderList = params => {
  return axios.post(apiData.share_queryFolder, params);
};
//分享页-查询文件夹内视频
const queryPluginList = params => {
  return axios.post(apiData.share_queryPlugins, params);
};
//分享页-查询
const getHomePageInfo = params => {
  return axios.get(apiData.share_getHomePageInfo, { params });
};

//对接思维
const getVideoDetail_sw = params => {
  return axios.get(apiData.siwei_videoDetail, { params });
};
//
const newGetVideoInfo = params => {
  return axios.get(apiData.newVideoInfo, { params });
};
const newQueryDir = params => {
  return axios.get(apiData.newQueryDir, { params });
};
const newQueryVideo = params => {
  return axios.get(apiData.newQueryVideo, { params });
};
const getUserInfo = params => {
  return axios.get(apiData.getUserInfo, { params });
};
const addVideoViewCnt = params => {
  return axios.post(apiData.addVideoViewCnt, params);
};
const videoLike = params => {
  return axios.post(apiData.videoLike, params);
};
const versionHistoryList = params => {
  return axios.get(getBaseUrl() + apiData.versionHistoryList, {
    params: params
  });
};
const checkKey = params => {
  return axios.post(apiData.checkKey, params);
};
const checkPsw = params => {
  return axios.post(apiData.checkPsw, params);
};
const getVideoById = params => {
  return axios.get(apiData.getVideoById, { params });
};
const getUserById = params => {
  return axios.get(apiData.getUserById, { params });
};
const queryCreator = () => {
  return axios.get(apiData.queryCreator);
};
const newGetWxSign = params => {
  return axios.get(apiData.newGetWxSign, { params });
};
const checkCode = (params) => {
  return axios.post(apiData.checkCode, params);
};
const userDetail=()=>{
    return axios.get( apiData.userDetail);
}
const viewList = (params) => {
  return axios.post(apiData.viewList, params);
};
const clearallViewList = (params) => {
  return axios.post(apiData.clearallViewList, params);
}
const updateOrg = (params) => {
  return axios.post(process.env.baseUrl.CONSOLE_URL + apiData.updateOrg , params);
}

export default {
  updateOrg,
  clearallViewList,
  viewList,
  userDetail,
  checkCode,
  newGetWxSign,
  getUserById,
  getVideoById,
  checkPsw,
  checkKey,
  versionHistoryList,
  getBaseUrl,
  videoLike,
  addVideoViewCnt,
  getUserInfo,
  newQueryVideo,
  newQueryDir,
  newGetVideoInfo,
  uploadSource,
  questionDetail,
  updateUserInfo,
  collect,
  cancelCollect,
  recommend,
  recommend1,
  cardList,
  cardDetail,
  search,
  examDetail,
  catalogueTabList,
  knowledgeDetail,
  chapterList,
  searchSuggest,
  examAnalysis,
  videoDetail,
  cardItemList,
  examSnapShot,
  videoSnapShot,
  getPaperContentById,
  questionSnapShot,
  addUserView,
  UserBehavior,
  userInfo,
  favouriteSnapShot,
  favouriteListOfData,
  examQuestionListByType,
  catalogueTabList_part,
  paragraphDetail,
  experimentList,
  experimentDetail,
  videoDetail_share,
  updateViewCount_share,
  updateLikeCount_share,
  shortenLink,
  queryFolderList,
  queryPluginList,
  wxSignature,
  xjsSignature,
  getHomePageInfo,
  getVideoDetail_sw,
  queryCreator
};



// WEBPACK FOOTER //
// ./src/js/API/index.js